import options from './notes.component';

export default {
    selector: 'dtNotes',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/notes/index.js